import {useState, useEffect, useContext} from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Toolbar from "@mui/material/Toolbar";
import Collapse from '@mui/material/Collapse';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { routes as routeList } from "routes";
import theme from "theme";
import 'i18n/config';
import { DataContext } from "contexts/DataContext";
import { useTranslation } from "react-i18next";

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

const AppDrawer = () => {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const location = useLocation();
  const [open, setOpen] = useState([] as any);
  const [routes, setRoutes] = useState([] as any);

  useEffect(() => {
    if(dataContext.loading) return;
    setRoutes(routeList);
    // apri tutte le sezioni di default
    setOpen(() => routeList.map(() => true));
  }, [dataContext.loading, dataContext.currentOrganization, dataContext.currentAssessment]);

  const handleClick = (index:number) => {
    console.log("Handle Clicked....",index,open[index]);
    setOpen(() => {
      const newOpen = [...open];
      newOpen[index] = !open[index];
      return newOpen;
    });
  }
  return (
    <div>
      <Toolbar />

      {routes.map((routeGroup: any, index: number) => {

        if(routeGroup.condition && !routeGroup.condition()) return null;
        return (
          <div key={index}>
          <List>
          {routeGroup.title &&
          <ListItem onClick={()=>handleClick(index)} sx={{cursor: routeGroup.collapsible ? 'pointer' : 'default'}}>
              <ListItemText
                primary={t(routeGroup.title)}
                primaryTypographyProps={{
                  textTransform: 'uppercase',
                  fontSize: 14,
                  fontWeight: 400,
                  color: (theme) => theme.palette.mode === 'dark'
                    ? theme.palette.secondary.main
                    : '#000000'
                }}
              />
              {routeGroup.collapsible && <>
              {open[index] ? <ExpandLess /> : <ExpandMore />}
              </>}
          </ListItem>
          }
          
          <Collapse
            in={routeGroup.values.filter((route: any) => location.pathname===route.path).length>0 || !routeGroup.collapsible || open[index]}
            timeout="auto"
            unmountOnExit
          >
          {routeGroup.values.map((route:any) => {
          if(route.condition && !route.condition()) return null;
     
          return (
              <ListItem
                key={route.name}
                selected={location.pathname===route.path}
                disablePadding
                component={Link}
                to={route.basePath ?? route.path}
              >
                  <ListItemButton
                    sx={{
                      py: 0.75,
                      px: 1,
                      pl: 2,
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: (theme) => theme.palette.action.hover,
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 24,
                        mr: 1.5,
                        color: (theme) => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                      }}
                    >
                      <route.icon />
                    </ListItemIcon>
                    <ListItemText
                      primary={t(route.name)}
                      primaryTypographyProps={{
                        fontSize: 16,
                        lineHeight: 1.2,
                        color: (theme) => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
            )
            })}          
            </Collapse>
          
            </List>
            <Divider />
            </div>
          )
      })}
    </div>
  );
};

export default AppDrawer